export const useGetGreetMessage = () => {
  let message = "";
  const today = new Date();
  const curHr = today.getHours();
  if (curHr < 12) {
    message = "Good Morning";
  } else if (curHr < 18) {
    message = "Good Afternoon";
  } else {
    message = "Good Evening";
  }
  return message;
};
